import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { AppState } from '../../../../../../app.service';
import { Service } from '../../../direct-connect.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
import { IpValidationUtils  } from '../../../../../../../common/validations/ip-validation-utils';
let $ = require('jquery');

@Component({
  selector: 'direct-connect-networks-new',
  styles: [require('../../../direct-connect.scss')],
  template: require('./dc-networks-new.html'),
    providers: [
    Service, TranslateService
  ]
})

export class DirectConnectNetworksNew {
  @Input() createData: any;

  @Input() isWizardOpen: boolean = false;
  @Input() stepId: number;
  @Input() showBusy: boolean = false;
  @Input() isNetworkCreatedNow: boolean = false;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private isTranslationready: boolean = true;
  private isNetworkCreated: boolean = true;
  private ipValidationUtils: IpValidationUtils = new IpValidationUtils();

  private dataModel = {
    dcName: '',
    gatewayAddress: '',
    maskBits: 0,
    ipRanges: [],
    isIpRangeValid: false,
    subnets: [],
    newUplinks: Object,
    stepId: -1
  };

  ngOnChanges(changes) {
      if (!this.isWizardOpen) {
          return;
      }

      if (this.stepId >= 0) {
        this.dataModel.stepId = this.stepId;
      }
      let data = this.createData;
      if (data && data.directConnectConfiguration) {
        this.isNetworkCreated  = (data.subnets && data.subnets.length > 0) ? true : false;
      }
  }

  constructor(public appState: AppState,
            public service: Service,
            private translate: TranslateService) {
      translate.use(GlobalVariables.LOCALE);
  }

  isFormValid() {
    let data = this.dataModel;
    if (!data.isIpRangeValid || !data.maskBits || !data.gatewayAddress || data.ipRanges.length === 0) {
        return false;
    }
    if (!this.ipValidationUtils.isIpValid(data.gatewayAddress)) {
        return false;
    }
        return true;
  }

  transitFormValid(event) {
    this.dataModel.isIpRangeValid = (event.valid) ? event.valid : false;
    this.emitData();

  }

  setIpRanges(event) {
    this.dataModel.ipRanges = (event.data) ? event.data : [];
    this.emitData();
  }

  emitData() {
    this.stepEventEmitter.emit(this.dataModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/connect-gateway/steps/dc-networks-new.component.ts